/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Loginb2cFooter from './loginb2cFooter';
// import bannerList from 'https://images.staticcontents.com/banners/list.json'

 let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class ExchangeCricketSEO extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection : "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }

    

    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]:false })
        
    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })
        
    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = ""){
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name){
        this.setState({selectedSection: this.state.selectedSection === name ? "" : name});
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
        <div className="radheexch radheexchlogin bg-white-login ">
            
            
            <Loginb2cHeader history={this.props.history}></Loginb2cHeader>
        {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
        <div className='login-mar-top100 '>
                <section className='sportbook-livecasino'>
                    <div>
                        <img alt="Exchange Banner" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/exchanges-banner.jpg"}  />

                    </div>
                    <div>
                        <div className="">
                            <div className='seo-content-page'>
                            <h2 align="center">Play and Earn Online with Your Favourite Game Cricket</h2>
<p>
    It is just five over to go, and Virat Kohli is on the crease batting at
    eighty-two; you are sure he will hit a boundary in this over. How many
    times has such a thing happened to you? If the answer is often,
    frustratingly often, you can use that intuition you have for the game to
    make money through <strong>Cricket gambling</strong>. Traditionally all
    forms of gambling, including <strong>Cricket gambling</strong>, have been
    seen as a sort of vice but betting or gambling is only bad if it becomes
    addictive. And for most people, it is not a problem if they are well aware
    of the risks of the game, it is not addictive, and they can control
    themselves.
</p>
<p>
    In fact, <strong>Cricket gambling, </strong>or gambling of any form for
    that matter, is not a lot different from many high-risk, high-return kinds
    of investments. That's perhaps why<strong> Cricket online betting </strong>
is growing so popular these days. And it is easy too. All you need for    <strong>Cricket online betting </strong>is some money; then, you can easily
    create an <strong>online Cricket id </strong>and start playing. Let us
    explore the various aspects of <strong>online betting games </strong>in
    detail.
</p>
<p>
    <strong>Cricket Betting Comes Naturally to Cricket Lovers</strong>
</p>
<p>
    Cricket is like a second religion to many; Cricket lovers know all the
    statistics, playing styles, and ratings of Cricketers better than
    Cricketers may know themselves. They can watch a test match for five
    continuous days and still not be disappointed when the match ends with a
    draw. That's just how much Cricket means to its lovers. If you are such a
    Cricket fan, then with so much of your mental space being occupied by the
    game, you are likely to develop an intuition for the game and can 'see'
    things coming. In such a case, <strong>Cricket online betting </strong>is
    just the next natural step for you.
</p>
<p>
    <strong>Important Perks of Cricket Gambling</strong>
</p>
<p>
    ● A good way of putting one's Cricket acumen into the application.
</p>
<p>
    ● A good way of making some money.
</p>
<p>
    ● A sense of adventure.
</p>
<p>
    ● Gives a financial expression to your emotional investment and your
    confidence in your favorite Cricketers.
</p>
<p>
    ● Far more skill-based than other forms of gambling that are completely
    luck-based.
</p>
<p>
    ● You are no longer just wasting time while watching Cricket.
</p>
<p>
    ● Watching Cricket is far more thrilling when you have your bets on.
</p>
<p>
    ● Most importantly, it is just fun.
</p>
<p>
    These perks will convince most Cricket lovers to give better a try. Before
    you raise any such questions, <strong>Cricket gambling </strong>is
    completely legal for all adults. So, you don't have to worry about doing
    anything illegal, and as you are not addicted or encouraging underage
    people to gamble, you aren't doing anything unethical either.
</p>
<p>
    <strong>Online Cricket Is Even More Fun</strong>
</p>
<p>
    The recent popularity of <strong>Cricket gambling </strong>is mostly owed
    to the emergence of <strong>online betting games</strong>. While online
    betting has been around for a while, the ever-increasing penetration of the
    internet and its increased and easy access through mobile apps and
increased availability of smartphones has catalysed the growth in    <strong>online betting games</strong>.
</p>
<p>
These online games are fairly easy. If you want to    <strong>bet fair Cricket</strong>, all you need is an internet connection,
    a device to access it, and an <strong>online Cricket id</strong>. There are
    several additional advantages of <strong>Cricket online betting</strong>
    apart from those mentioned above:
</p>
<p>
    ● Far more convenient than traditional Cricket bettering as you don't have
    to meet or call anyone; you can just do it through a few simple clicks on
    your screen at any place.
</p>
<p>
    ● Cricket data is far more readily available online.
</p>
<p>
    ● <strong>Cricket online betting</strong> offers far better rewards for
    bets in general.
</p>
<p>
    ● The platforms for <strong>online betting games </strong>are far better
    regulated.
</p>
<p>
    ● You can readily cash in your winnings.
</p>
<p>
    ● As mentioned above, it is even more fun than traditional betting.
</p>
<p>
    ● It is simply too irresistible for true Cricket lovers.
</p>
<p>
    From the above discussion, we can easily conclude that online Cricket
    betting games are the perfect way to <strong>bet fair Cricket</strong>.
</p>
<p>
    <strong>The Perfect Place For Cricket Betting</strong>
</p>
<p>
    It is really crucial when it comes to <strong>Cricket gambling</strong>
that one should choose one's platform carefully. One should only get    <strong>an online Cricket id</strong> only after careful scrutiny of the
    vendor. Some of the things to consider while choosing the vendor include
    the privacy policy, safety of information and one's money, kinds of bets
    offered, and the reward payback time period typically required to cash the
    winnings.
</p>
<p>
    Most people will find that 1Xbook will come out on top with all these
criteria. What makes us a favorite among those looking to    <strong>bet fair Cricket </strong>is our highly innovative and convenient
    options. With 1Xbook, you can bet on international matches, league matches
    as well domestic matches. We don't show gender discrimination either - you
    can bet upon both men's and women's Cricket. Our service is not limited to
Cricket either, but we offer several other    <strong>online betting games </strong>as well. And you can play all these
    games using Indian currency only - thus providing an easy platform to
    millions of Cricket lovers.
</p>
<p>
    It is easy to <strong>bet fair Cricket </strong>with us, and it just takes
    a few minutes to create your <strong>online Cricket id. </strong>You can
    easily check your bets with the bet slip we provide on our website. It is
crucial to play it smart when you are playing    <strong>online betting games</strong>. Thus, one should carefully keep
    sight of scores when betting. It is easy to do so when you bet with us. In
    case you have any doubts or queries, you can chat with us through a website
    online or contact us through one of several social media links provided on
    the website.
</p>
<p>
Before going further, let us look at some of the games where one can    <strong>bet fair Cricket</strong>:
</p>
<p>
    ● <strong>Men's International Cricket</strong> - Men's international
    Cricket is the face of Cricket - it's where the biggest stars are and where
most bets have been traditionally made. If you have an    <strong>online Cricket id</strong>, you will notice that the rewards we are
    offering in these games are simply irresistible.
</p>
<p>
    ● <strong>Indian Premier League</strong> - Cricket may have been born in
    England, but through that right that comes from limitless love and
    devotion, Indians have owned the game. And it is in India that this sport
    feels at home. It is in the Indian Premier League (IPL) that this
    inseparability between this nation and the sport finds its truest
    expression.
</p>
<p>
    Cashing on Indians' limitless hunger for this sport and the invention of
    T20, the newest and shortest version of the game, IPL has grown even more
    popular among many Indians than the international games. That's perhaps why
    even international Cricket must stop for months when IPL matches are in
    progress.
</p>
<p>
Needless to say, IPL also has the hottest bets when it comes to    <strong>Cricket online betting</strong>. A perk of these bets is that the
    results are decided in far lesser time as an IPL match takes only half a
    day to complete.
</p>
<p>
    ● <strong>Women's Cricket</strong> - With an increased feminist consciousness and media
    attention, women's Cricket is finally achieving the long-due followership.
    At the moment, with lesser viewership than many other forms of the game, it
    has become a niche betting scene where there are fewer bets than many other
    versions of the game.
</p>
<p>
    Of course, these are only some of the various games to bet on. There are,
    of course, many other subsets of Cricket, such as World Cup, T20 World Cup,
    Champions Trophy, Ashes, League Matches, etc., on which one can bet.
</p>
<p>
    <strong>Getting Started With Cricket Betting</strong>
</p>
<p>
    Are you a beginner in <strong>Cricket online betting</strong>? Well, in
    that case, we shall wish you the best of luck, to begin with, but we shall
    go further than just wishing you. We shall recommend a few tips that come
    in handy when playing <strong>online betting games</strong>:
</p>
<p>
    ● <strong>Play legally</strong> - It is for very good reasons that only
    adults can have an <strong>online Cricket id </strong>for betting, as
    gambling can become addictive and may negatively impact minds that aren't
    fully matured.
</p>
<p>
    ● <strong>Play smartly</strong> - While you may have occasional luck while
    betting blindly, if you hope to have any kind of lasting luck, you must
    learn to study the Cricket conditions, statics, players' forms, etc., to be
    able to make smart forecasts and bet accordingly. Otherwise, you will be at
    the same disadvantage as those doing it as a blind person is at when
    shooting a target next to those who can see their target.
</p>
<p>
    ● <strong>Learn with baby steps</strong> - Don't go all out betting big
    from the beginning. It is essential to first learn the various intricacies
    of online gambling by making only small bets in the beginning.
</p>
<p>
● <strong>Play responsibly</strong> - If you want to    <strong>bet fair Cricket</strong>, then know that it is not all fun and no
    responsibility. Like all kinds of financial decisions, it involves its own
    financial risks, and you do stand a chance of losing money; thus, financial
    prudence and responsibility are essential. Thus, no matter how good you
    are, it is crucial to bet no more than you can afford to lose. It is always
    a smart strategy to fix a limit for yourself as to how much you are willing
    to bet in a given period and respect that limit.
</p>
<p>
    ●
    <strong>
        Self-discipline is defining virtue of a responsible gambler
    </strong>
    - Like we just mentioned, respecting one's financial limits is critical to
    responsible gambling. If you are facing trouble in disciplining yourself in
    this regard, then you must take measures toward it. If it is still not
    helping, then you must stop it altogether as the hard fact is that, in that
    case, gambling is not for you.
</p>
<p>
    ● <strong>Don't be afraid to ask for help</strong> - It is also equally
    important to know that if you have a problem to stop gamble, it is okay to
    ask for help. It is not easy to fight addictions, but it is crucial for
    your own good and that of your family to do so.
</p>
<p>
    ● <strong>Know that Cricket gambling doesn't replace your day job</strong>
    - Cricket gambling may result in huge earnings, but it won't become a
    replacement for your day job. It is important to remember that any earning
    from Cricket gambling should only be thought of as a bonus.
</p>
<p>
    As you start your Cricket gambling journey, we hope that these tips and
    notes of caution will come in handy for you.
</p>
<p>
    <strong>The Smartest Way of Cricket Gambling for Everyone</strong>
</p>
<p>
    1xBook offers smart Cricket gambling solutions for everyone. We have used a
    deep understanding of our customers' minds to meet their various needs as
    they bet using our platform. Being a secure and powerful platform, we are
    trusted by numerous customers already; we know exactly how to keep the
    information about your bet readily available to you. As an Indian, you will
    also get a chance to play in Indian currency rather than having to go for
    some other currency.
</p>
                            </div>
                        </div>
                        
                    </div>
                </section>
            </div>


            <Loginb2cFooter history={this.props.history}></Loginb2cFooter>

            
        </div>)
        
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ExchangeCricketSEO);